import { FetchResult } from '@apollo/client'
import { MagentoGetCartGiftMessageOutput } from 'lib/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import gql from 'graphql-tag'

export interface VisitureGetCartGiftMessageQueryObject {
  visitureGetCartGiftMessage: {
    __args: {
      cart_id: string
    }
    message: boolean
    recipient: boolean
    sender: boolean
    items: {
      item_id: boolean
      message: boolean
      recipient: boolean
      sender: boolean
    }
  }
}

export const visitureGetCartGiftMessageQueryObject: VisitureGetCartGiftMessageQueryObject = {
  visitureGetCartGiftMessage: {
    __args: {
      cart_id: ''
    },
    message: true,
    recipient: true,
    sender: true,
    items: {
      item_id: true,
      message: true,
      recipient: true,
      sender: true
    }
  }
}

export type GetCartGiftMessageQuery = (cartId: string) => Promise<FetchResult<{ visitureGetCartGiftMessage: MagentoGetCartGiftMessageOutput }>>

export const createGetCartGiftMessageQuery = ({ getQueries }: ServiceDependencies): GetCartGiftMessageQuery => async (cartId) => {
  const query = getQueries().visitureGetCartGiftMessageQuery
  query.visitureGetCartGiftMessage.__args.cart_id = cartId

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
